import { render, staticRenderFns } from "./PatientsForCallerMinimalRoom.vue?vue&type=template&id=1e7e9e89&scoped=true&"
import script from "./PatientsForCallerMinimalRoom.vue?vue&type=script&lang=js&"
export * from "./PatientsForCallerMinimalRoom.vue?vue&type=script&lang=js&"
import style0 from "./PatientsForCallerMinimalRoom.vue?vue&type=style&index=0&id=1e7e9e89&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e7e9e89",
  null
  
)

export default component.exports